module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "p-team"
  }, [_c('div', {
    staticClass: "p-team__main-container u-relative"
  }, [_c('div', {
    staticClass: "p-team__main-container__border u-absolute u-pos-tl u-zindex--1 u-fit-h u-bg--brand-primary u-overflow-h"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-team__container u-relative u-zindex--2 u-marg-l-w3of12 u-marg-x-auto@sm u-w8of12 u-w10of12@sm"
  }, [_c('div', {
    staticClass: "p-team__container__wrapper u-relative"
  }, [_c('div', {
    staticClass: "p-team__container__wrapper__teams-container u-relative"
  }, _vm._l((_vm.teams), function(pole, poleIndex) {
    return _c('div', {
      key: poleIndex,
      staticClass: "p-team__container__wrapper__teams-container__team",
      class: ['js-team-container--' + poleIndex, 'p-team__container__wrapper__teams-container__team--' + poleIndex]
    }, [_c('div', {
      staticClass: "u-flex u-flex-jc--space-between"
    }, [(_vm.$root.width > 770) ? _c('div', {
      staticClass: "p-team__container__wrapper__teams-container__team__left js-left-container u-relative"
    }, [_c('div', {
      staticClass: "p-team__container__wrapper__teams-container__team__left-wrapper js-left-wrapper u-fit-w"
    }, [_c('h2', {
      staticClass: "p-team__container__wrapper__title u-relative t-fsize--h1 t-fweight--light u-color--white"
    }, [_c('div', {
      staticClass: "p-team__container__wrapper__title-small"
    }, [_vm._v("\n                                            Practical Team\n                                        ")]), _vm._v(" "), _c('div', {
      staticClass: "p-team__container__wrapper__title-big u-relative"
    }, [_vm._v("\n                                            " + _vm._s(pole.name) + "\n\n                                            "), _c('div', {
      staticClass: "p-team__container__wrapper__title__line-container u-absolute"
    }, [_c('div', {
      staticClass: "p-team__container__wrapper__title__line u-relative u-fit u-bg--white",
      class: ['p-team__container__wrapper__title__line--' + poleIndex, _vm.lineAdvisorsIsActivated ? 'is-active' : 'is-not-active']
    })])])]), _vm._v(" "), _vm._l((pole.members), function(member, memberIndex) {
      return (memberIndex % 2 === 0) ? _c('app-team-single', {
        key: memberIndex,
        attrs: {
          "member": member,
          "index": memberIndex,
          "position": "left"
        }
      }) : _vm._e()
    })], 2)]) : _vm._e(), _vm._v(" "), (_vm.$root.width > 770) ? _c('div', {
      staticClass: "p-team__container__wrapper__teams-container__team__right js-right-container u-relative"
    }, [_c('div', {
      staticClass: "p-team__container__wrapper__teams-container__team__right-wrapper js-right-wrapper u-fit-w"
    }, _vm._l((pole.members), function(member, memberIndex) {
      return (memberIndex % 2 !== 0) ? _c('app-team-single', {
        key: memberIndex,
        attrs: {
          "member": member,
          "index": memberIndex,
          "position": "right"
        }
      }) : _vm._e()
    }))]) : _vm._e(), _vm._v(" "), (_vm.$root.width <= 770) ? _c('div', {
      staticClass: "p-team__container__wrapper__teams-container__team__mobile u-width--50p"
    }, [_c('h2', {
      staticClass: "p-team__container__wrapper__title u-relative t-fsize--h1 t-fweight--light u-color--white"
    }, [_c('div', {
      staticClass: "p-team__container__wrapper__title-small"
    }, [_vm._v("\n                                        Practical Team\n                                    ")]), _vm._v(" "), _c('div', {
      staticClass: "p-team__container__wrapper__title-big u-relative"
    }, [_vm._v("\n                                        " + _vm._s(pole.name) + "\n\n                                        "), _c('div', {
      staticClass: "p-team__container__wrapper__title__line u-absolute u-bg--white"
    })])]), _vm._v(" "), _vm._l((pole.members), function(member, memberIndex) {
      return _c('app-team-single', {
        key: memberIndex,
        staticClass: "u-marg-t-xxl",
        attrs: {
          "member": member,
          "index": memberIndex
        }
      })
    })], 2) : _vm._e()])])
  }))])])]), _vm._v(" "), _c('app-newsletter'), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7872dfac"}!./src/scripts/components/page-team/template.html
// module id = 476
// module chunks = 0